export default "__VITE_ASSET__Cd42hZ_K__"